export default "__VITE_ASSET__1428513e__"